module.exports = __webpack_public_path__ + "static/media/custom-ex-4.4348411d.jpg";